import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyServiceApi {

  constructor(private http: HttpClient) { }

    getCompanies(allCompanies: boolean = false) {
        const params = allCompanies ? { params: { all: 'true' } } : {};
        return this.http.get(`${environment.apiUrl}/globalvision/company`, {
            headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || ''),
            ...params
        })
    }

    getCompany(id:any) {
      return this.http.get(`${environment.apiUrl}/globalvision/company/get/${id}`, {
          headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      }).toPromise();
  }

    // addCompany(company:{}) {
    //   return this.http.get(`${environment.apiUrl}/globalvision/company/${profileId}`, {
    //     headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    //   })
    // }
    // getPermissions(type?: string) {
    //     return this.http.get(`${environment.apiUrl}/common/permission`, {
    //     headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || ''),
    //     params: type ? { type } : undefined
    //     })
    // }

    // getProfilePermissions(profileid: number) {
    //     return this.http.get(`${environment.apiUrl}/common/permission/getByProfile/${profileid}`, {
    //     headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    //     })
    // }

    // updateDocsProfilePermissions(newpermissions: {permissionid: number, profileid: number, value: boolean}[], domain: string) {
    //     return this.http.post(`${environment.apiUrl}/docuvision/directory/changepermission`, { newpermissions, domain }, {
    //     headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    //     })
    // }
}
